import React from 'react'
import ReactDOM from 'react-dom'
import createSagaMiddleware from 'redux-saga'
import { Provider } from 'react-redux'
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import '@babel/polyfill'
import 'isomorphic-fetch'

import progressReducer from './state/progress/progressReducer'
import loginReducer from './state/login/loginReducer'
import loginSaga from './state/login/loginSaga'
import LoginPage from './components/scenes/login/LoginPage.jsx'

export default function SetupLoginPage(rootId, config){
  config = {    
    ...config
  }

  const sagaMiddleware = createSagaMiddleware()
  const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose

  const store = createStore(
    combineReducers({
      progress: progressReducer,
      login: loginReducer
    }),
    composeEnhancer(
      applyMiddleware(
        sagaMiddleware
      )
    )
  )

  sagaMiddleware.run(loginSaga, config)

  ReactDOM.render(
    <Provider store={store} >
      <LoginPage />
    </Provider>,
    document.getElementById(rootId)
  )
}

